/**
 * Helper functions for diagnoses operations
 */

export const findAnorexiaDiagnosis = (diagnosesData) => {
  if (!diagnosesData?.data) {
    return -1;
  }
  return diagnosesData.data.findIndex(diagnose => diagnose.isAnorexia);
};

export const isAnorexiaDiagnosis = (diagnosesData, diagnosisIndex) => {
  if (!diagnosesData?.data || diagnosisIndex < 0 || diagnosisIndex >= diagnosesData.data.length) {
    return false;
  }
  return diagnosesData.data[diagnosisIndex]?.isAnorexia === true;
};
